import React, { Fragment } from 'react';

const UberDriver = () => (
	<Fragment>
		<p>
			Autzu cars will automatically be added to your Uber Driver account.
			When you are assigned an Autzu car, you can then choose that vehicle
			in the vehicle list on your Uber Driver app.{' '}
		</p>
		<br />
		<div className="block-video">
			<iframe
				src="https://www.youtube.com/embed/GDJkJ0-s9xU"
				frameBorder="0"
				allowFullScreen
				title="Instructions"
			/>
		</div>
		<br />
		<ol>
			<li>Open the Uber Driver app</li>

			<li>Tap on the menu icon in the top left corner</li>

			<li>Tap on “Account”, then “Vehicles”</li>
			<li>
				Use the search bar to enter license plate you have been assigned
			</li>
			<li>Tap on the vehicle plate</li>
			<li>Go back to the main screen, go online</li>
		</ol>
	</Fragment>
);

export default UberDriver;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/UberDriver.js